// extracted by mini-css-extract-plugin
export default {"wrap":"ListHeader_wrap__ApXO2"};